import React, { useCallback, useEffect, useState } from "react";

import { Alert } from "components/Alert";
import { Button } from "components/Button";
import { PageWithNav } from "components/PageWithNav";
import { Spinner } from "components/Spinner";
import { TextEditor } from "components/TextEditor";
import api from "utils/api";
import { useToastContext } from "context/ToastContext";

export const TermsAndConditions = () => {
  const { notify } = useToastContext();
  const [terms, setTerms] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [hasError, setHasError] = useState(false);

  const loadTerms = useCallback(async () => {
    try {
      const response = await api.get("/terms-and-conditions");
      const termsContent = response.data.termsContent;
      setTerms(termsContent);
    } catch {
      setHasError(true);
    } finally {
      setLoadingData(false);
    }
  }, []);

  useEffect(() => {
    loadTerms();
  }, [loadTerms]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (window.confirm("Are you sure you want to update terms and conditions?")) {
      const formData = new FormData(event.target);
      formData.set("content", terms);

      try {
        setIsLoading(true);
        const response = await api.put("/terms-and-conditions", formData);
        setIsLoading(false);
        notify({ title: "Success", description: response.data?.message || "Terms and conditions updated", type: "success" });
      } catch (e) {
        setIsLoading(false);
        console.error(e);
      }
    }
  };

  return (
    <PageWithNav>
      <h1 className="mb-5 pe-4 text-xl font-semibold text-neutral-900">Update Terms and Conditions</h1>
      <Alert type="primary">
        <span>
          If you update terms and condtions, <strong className="underline">ALL</strong> users will have to agree with new terms, so use it wisely.
        </span>
      </Alert>
      {loadingData && (
        <div className="flex justify-center">
          <Spinner size="lg" color="primary" />
        </div>
      )}
      {hasError && !isLoading && <div className="flex justify-center text-xl font-semibold leading-3 text-red-900">There was a problem, refresh the page to try again.</div>}
      {!hasError && !loadingData && (
        <form onSubmit={handleSubmit} data-testid="terms-form">
          <TextEditor value={terms} onChange={setTerms} id="terms" label="Terms and Conditions" />
          <div className="my-4">
            <Button disabled={isLoading} loading={isLoading} type="submit" color="primary" size="sm">
              Update
            </Button>
          </div>
        </form>
      )}
    </PageWithNav>
  );
};
